module.exports = __webpack_public_path__ + "img/pixartprinting-instagram-3.c0a2246.png";